import component from './componentBinding'
import slot from './slotBinding'
export const bindings = { component, slot }
